
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clases/curso-scrum-master",
      function () {
        return require("private-next-pages/clases/curso-scrum-master.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clases/curso-scrum-master"])
      });
    }
  